<template>
  <div>
    <user-detail-title
      first-bread="首页管理"
      second-bread="资质信誉"
      third-bread="资质信誉修改"
      first-url="/user/sign"
      second-url="/user/quality"
      title-name="资质信誉修改"
    >
    </user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" >
        <el-form-item label="ID" >
          <el-input :placeholder="Clist.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="文字描述">
          <el-input  type="textarea"
                     :rows="4"
                     v-model="Clist.description" ></el-input>
        </el-form-item>
        <el-form-item label="所属类型">
          <el-select v-model="Clist.type" placeholder="请选择">
            <el-option
              v-for="item in ChangeData"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button @click="handleChange">修改</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "QualityChange",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        ChangeData:null,
        Checked:[],
        Clist: {
          'id':this.$route.params.id,
          'type':null,
          'description':null,
          'photoUrl':null,
        },//表示Change添加的数据
      }
    },
    created() {
      this.GetChangeData(this.$route.params.id)
    },
    methods:{
      GetUrlList(file){
        this.Clist.photoUrl=file.data;
      },
      GetChangeData(id){
        this.$axios.get('/api/certification/getTypeList').then(res=>{
          this.ChangeData=res.data.data;
        })
      },
      handleChange(){
        if (this.Clist.type){
          if (this.Clist.description || this.Clist.photoUrl) {
            this.$axios.post('/api/certification/update',this.Clist).then(res=>{
              if(res.data.success == true){
                this.$message({
                  message:'修改成功',
                  type:'success'
                })
              }
            })
          }
          else {
            this.$message.warning('请上传图片或填入描述')
          }
        } else {
          this.$message.error('类型必须选择')
        }

      }
    }
  }
</script>

<style scoped>

</style>